import * as React from 'react';
import Avatar from '@mui/material/Avatar';
import Box from '@mui/material/Box';
import Chip from '@mui/material/Chip';
import IconButton from '@mui/material/IconButton';
import NotificationsIcon from '@mui/icons-material/Notifications';
import Tooltip from '@mui/material/Tooltip';
import ApartmentOutlinedIcon from '@mui/icons-material/ApartmentOutlined';
import AdminPanelSettingsOutlinedIcon from '@mui/icons-material/AdminPanelSettingsOutlined';
import { useNavigate, useLocation } from 'react-router-dom';

import { appActions } from '../../redux/actions';
import { useDispatch, useSelector } from 'react-redux';
import UserAccountMenu from '../UserAccountMenu';
import useAuth from '../../hooks/useAuth';
import { isTenantWorkspacePath } from '../../config/navigation';

export default function TopBar({ }) {

    const dispatch = useDispatch()
    const navigate = useNavigate();
    const location = useLocation();
    const userAccountMenu = useSelector(state => state?.app?.userAccountMenu || false);
    const {
        isTenantUser,
        isSystemUser,
        contextLabel,
        tenantId,
        activeTenantName,
        activeTenantId,
        displayName,
        initials,
    } = useAuth();
    const viewingTenantWorkspace =
        isSystemUser && isTenantWorkspacePath(location.pathname);

    const open = Boolean(userAccountMenu);
    const handleClick = (event) => {
        dispatch(appActions.userAccountMenu(event.currentTarget))
    };

    return (
        <React.Fragment>
            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
                <Chip
                    size="small"
                    icon={
                        isTenantUser || viewingTenantWorkspace
                            ? <ApartmentOutlinedIcon />
                            : <AdminPanelSettingsOutlinedIcon />
                    }
                    label={
                        isTenantUser
                            ? contextLabel || "Tenant"
                            : viewingTenantWorkspace
                              ? `System · ${activeTenantName || activeTenantId}`
                              : "System"
                    }
                    title={
                        isTenantUser && tenantId
                            ? `Tenant ID: ${tenantId}`
                            : viewingTenantWorkspace
                              ? `Viewing ${activeTenantName || activeTenantId} tenant resources. Click to switch tenant.`
                              : "System resources"
                    }
                    onClick={
                        viewingTenantWorkspace
                            ? () => navigate("/tenantmgmt")
                            : undefined
                    }
                    sx={{
                        display: { xs: "none", sm: "inline-flex" },
                        fontWeight: 600,
                        cursor: viewingTenantWorkspace ? "pointer" : "default",
                        backgroundColor:
                            isTenantUser || viewingTenantWorkspace ? "primary.light" : "#f1f5f9",
                        color:
                            isTenantUser || viewingTenantWorkspace ? "primary.dark" : "text.secondary",
                        "& .MuiChip-icon": {
                            color:
                                isTenantUser || viewingTenantWorkspace
                                    ? "primary.main"
                                    : "text.secondary",
                        },
                    }}
                />
                <Tooltip title="Notifications">
                    <IconButton
                        size="large"
                        aria-label="show notifications"
                        sx={{
                            color: "text.secondary",
                            "&:hover": { color: "primary.main", backgroundColor: "primary.light" },
                        }}
                    >
                        <NotificationsIcon />
                    </IconButton>
                </Tooltip>
                <Tooltip title={displayName || "Account"}>
                    <IconButton
                        size="large"
                        edge="end"
                        aria-label="account of current user"
                        aria-controls={open ? "account-menu" : undefined}
                        aria-haspopup="true"
                        onClick={handleClick}
                        sx={{
                            ml: 0.5,
                            p: 0.5,
                            "&:hover": { backgroundColor: "primary.light" },
                        }}
                    >
                        <Avatar
                            sx={{
                                width: 32,
                                height: 32,
                                bgcolor: "primary.main",
                                fontSize: 14,
                                fontWeight: 700,
                            }}
                        >
                            {initials}
                        </Avatar>
                    </IconButton>
                </Tooltip>
            </Box>
            <UserAccountMenu />
        </React.Fragment>
    );
}
